import { render, staticRenderFns } from "./Endings.vue?vue&type=template&id=08096f04&scoped=true&"
import script from "./Endings.vue?vue&type=script&lang=js&"
export * from "./Endings.vue?vue&type=script&lang=js&"
import style0 from "./Endings.vue?vue&type=style&index=0&id=08096f04&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08096f04",
  null
  
)

export default component.exports